import React, {Component} from 'react'
import PropTypes from "prop-types";

export default class DataGridColumn extends Component {
    static propTypes = {
        /**
         * set width value for wrapper(th) styles
         */
        width: PropTypes.string,
        /**
         *  Component inner (can be anything)
         */
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]).isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {children, width, colspan, className, ...rest} = this.props;

        const styles = {
            width: width ? width : null
        };

        return (
            <th className={className || ''} style={styles} colSpan={colspan} {...rest}>
                {children}
            </th>
        )
    }
}
